import { EMPTY_PROPOSAL_COPY_FOR_RECAL_ENTITY, ProposalCopyingForRecalEntity } from "domain/entity/ProposalCopyingForRecal/ProposalCopyingForRecalEntity";
import { EMPTY_PROPOSAL_COPY_FOR_RECAL_ITEM_ENTITY, ProposalCopyingForRecalItemEntity } from "domain/entity/ProposalCopyingForRecal/ProposalCopyingForRecalItemEntity";
import { EMPTY_PROPOSAL_COPY_FOR_RECAL_SEARCH_CRITERIA, ProposalCopyingForRecalSearchCriteria } from "domain/entity/ProposalCopyingForRecal/ProposalCopyingForRecalSearchCriteria";
import { StandardProposalItemEntity } from "domain/entity/StandardProposal/StandardProposalItemEntity";
import { EMPTY_STANDARD_PROPOSAL_ITEM_PREVIEW_ENTITY, StandardProposalItemPreviewEntity } from "domain/entity/StandardProposal/StandardProposalItemPreviewEntity";
import { EMPTY_STD_PROPOSAL_COPY_TO_ENTITY, StdProposalCopyToEntity } from "domain/entity/StandardProposal/StdProposalCopyToEntity";
import { EMPTY_STD_PROPOSAL_COPY_TO_NEW_PROPOSAL_ENTITY, StdProposalCopyToNewProposalEntity } from "domain/entity/StandardProposal/StdProposalCopyToNewProposalEntity";
import { EMPTY_STD_PROPOSAL_COPY_TO_PROPOSAL_ENTITY, StdProposalCopyToProposalEntity } from "domain/entity/StandardProposal/StdProposalCopyToProposalEntity";
import { EMPTY_STD_PROPOSAL_TARIFF_ITEM_TIER_ENTITY, StdProposalTariffItemTierEntity } from "domain/entity/StandardProposal/StdProposalTariffItemTierEntity";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface ProposalCopyingForRecalDropdownOptions {

    companyCodeDropdownOptions: DropdownProps[],
    operatingTmlDropdownOptions: DropdownProps[],
    companyCodeProposalNoDropdownOptions: DropdownProps[],
    tariffTypeDropdownOptions: DropdownProps[],
    currencyCodeDropdownOptions: DropdownProps[],
}
export interface ProposalCopyingForRecalChangeState extends BaseViewChangeSate {
}

export interface ProposalCopyingForRecalModel {
    masterState: ProposalCopyingForRecalChangeState,
    isLoading: boolean,
    isShowCriteriaPanel: boolean,
    proposalCopyingForRecalList: ProposalCopyingForRecalEntity[],
    selectedRows: ProposalCopyingForRecalEntity[],
    currentSelectedRow: ProposalCopyingForRecalEntity,
    isForRecal: boolean,
    isForRecalCount: number,
    searchCriteria: ProposalCopyingForRecalSearchCriteria,
    dynamicOptions: ProposalCopyingForRecalDropdownOptions,
    searchStatus: string,
    isShowTariffItemPanel: boolean,
    isShowCopyToCompanyPanel: boolean,
    tariffItemList: ProposalCopyingForRecalItemEntity[],
    selectedItemRows: ProposalCopyingForRecalItemEntity[],
    currentItemRow: ProposalCopyingForRecalItemEntity,
    standardProposalItemTIerList: StandardProposalItemEntity[],
    forceRefresh: boolean,
    isCopyToNewProposal: boolean,
    companyCodeList: string[],
    allFormState: { [key: string]: string },
    copyToPercentageList: StdProposalCopyToEntity[],
    copyToPercentage: StdProposalCopyToEntity,
    copyToEditPercentage: StdProposalCopyToEntity,
    copyToProposalList: StdProposalCopyToProposalEntity[],
    copyToNewProposalList: StdProposalCopyToNewProposalEntity[],
    copyToEditNewProposal: StdProposalCopyToNewProposalEntity,
    copyToEditProposalNo: StdProposalCopyToProposalEntity,
    copyToProposalNo: StdProposalCopyToProposalEntity,
    isEditProposalNo: boolean,
    isEditNewProposalNo: boolean,
    isEditPercentage: boolean,
    isShowEditPanel: boolean,
    isShowEditTierPanel: boolean,
    isShowCopyEditTierPanel: boolean,
    isEditTier: boolean,
    isEdit: boolean,
    currentItemTier: StdProposalTariffItemTierEntity,
    selectedItemTierRows: StdProposalTariffItemTierEntity[],
    itemTierList: StdProposalTariffItemTierEntity[],
    currentEditItemTier: StdProposalTariffItemTierEntity,
    isShowTariffItemTierPanel: boolean,
    isShowPreviewPanel: boolean,
    copyToNewTariffItemTierList: StdProposalTariffItemTierEntity[],
    copyToNewTariffList: StandardProposalItemPreviewEntity[],
    selectCopyToNewTariff: StandardProposalItemPreviewEntity,
}

export const EMPTY_PROPOSAL_COPY_FOR_RECAL_MODEL: ProposalCopyingForRecalModel = {
    allFormState: {},
    isLoading: false,
    isShowCriteriaPanel: false,
    proposalCopyingForRecalList: [],
    selectedRows: [],
    isForRecal: false,
    isForRecalCount: 0,
    searchCriteria: { ...EMPTY_PROPOSAL_COPY_FOR_RECAL_SEARCH_CRITERIA },
    dynamicOptions: {
        companyCodeDropdownOptions: [],
        operatingTmlDropdownOptions: [],
        companyCodeProposalNoDropdownOptions: [],
        tariffTypeDropdownOptions: [],
        currencyCodeDropdownOptions: []
    },
    searchStatus: "",
    isShowTariffItemPanel: false,
    isShowCopyToCompanyPanel: false,
    tariffItemList: [],
    standardProposalItemTIerList: [],
    forceRefresh: false,
    selectedItemRows: [],
    currentSelectedRow: { ...EMPTY_PROPOSAL_COPY_FOR_RECAL_ENTITY },
    companyCodeList: [],
    isCopyToNewProposal: false,
    copyToPercentageList: [],
    copyToProposalList: [],
    copyToNewProposalList: [],
    copyToPercentage: { ...EMPTY_STD_PROPOSAL_COPY_TO_ENTITY },
    copyToEditPercentage: { ...EMPTY_STD_PROPOSAL_COPY_TO_ENTITY },
    isEditProposalNo: false,
    isEditNewProposalNo: false,
    isEditPercentage: false,
    copyToEditNewProposal: { ...EMPTY_STD_PROPOSAL_COPY_TO_NEW_PROPOSAL_ENTITY },
    copyToEditProposalNo: { ...EMPTY_STD_PROPOSAL_COPY_TO_PROPOSAL_ENTITY },
    copyToProposalNo: { ...EMPTY_STD_PROPOSAL_COPY_TO_PROPOSAL_ENTITY },
    isShowEditPanel: false,
    currentItemRow: { ...EMPTY_PROPOSAL_COPY_FOR_RECAL_ITEM_ENTITY },
    currentItemTier: { ...EMPTY_STD_PROPOSAL_TARIFF_ITEM_TIER_ENTITY },
    selectedItemTierRows: [],
    currentEditItemTier: { ...EMPTY_STD_PROPOSAL_TARIFF_ITEM_TIER_ENTITY },
    itemTierList: [],
    isShowEditTierPanel: false,
    isEdit: false,
    isShowPreviewPanel: false,
    copyToNewTariffItemTierList: [],
    copyToNewTariffList: [],
    selectCopyToNewTariff: { ...EMPTY_STANDARD_PROPOSAL_ITEM_PREVIEW_ENTITY },
    isShowTariffItemTierPanel: false,
    isShowCopyEditTierPanel: false,
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        }
    },
    isEditTier: false
}